// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://app.ivydental.com.tw/mobile/php/',
  chatApiUrl: 'https://chat.ivydental.com.tw/php/',
  socketUrl: 'https://chat.ivydental.com.tw',
  oneSignalAppId: '67faeb85-f54e-4247-9994-1eb639893de0',
  enableLogging: true,
  enableDebugMode: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
